import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAssetImage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <g opacity={0.5}>
      <path
        fill="url(#Asset_Image_svg__a)"
        d="m10.438 15.26 2.437-2.7a.96.96 0 0 1 1.412-.014l2.547 2.712c.11.118.027.31-.135.31h-6.124a.184.184 0 0 1-.137-.307Z"
      />
      <path
        fill="url(#Asset_Image_svg__b)"
        d="m3.267 15.057 4.33-4.798a1.28 1.28 0 0 1 1.883-.019l4.519 4.812a.31.31 0 0 1-.226.522H3.496a.31.31 0 0 1-.23-.517Z"
      />
      <circle
        cx={13.576}
        cy={5.923}
        r={1.496}
        fill="url(#Asset_Image_svg__c)"
      />
    </g>
    <defs>
      <linearGradient
        id="Asset_Image_svg__a"
        x1={15.819}
        x2={7.121}
        y1={14.564}
        y2={14.23}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="var(--dataviz-color-sequential-blue-scale06)" />
        <stop
          offset={1}
          stopColor="var(--dataviz-color-sequential-blue-scale02)"
        />
      </linearGradient>
      <linearGradient
        id="Asset_Image_svg__b"
        x1={12.297}
        x2={-2.299}
        y1={13.888}
        y2={13.328}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="var(--dataviz-color-sequential-blue-scale06)" />
        <stop
          offset={1}
          stopColor="var(--dataviz-color-sequential-blue-scale02)"
        />
      </linearGradient>
      <linearGradient
        id="Asset_Image_svg__c"
        x1={14.511}
        x2={10.771}
        y1={6.624}
        y2={6.546}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="var(--dataviz-color-sequential-blue-scale06)" />
        <stop
          offset={1}
          stopColor="var(--dataviz-color-sequential-blue-scale02)"
        />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgAssetImage;
